import { render, staticRenderFns } from "./CatalogueProductInformationsItem.vue?vue&type=template&id=6802da98&scoped=true"
import script from "./CatalogueProductInformationsItem.vue?vue&type=script&lang=js"
export * from "./CatalogueProductInformationsItem.vue?vue&type=script&lang=js"
import style0 from "./CatalogueProductInformationsItem.vue?vue&type=style&index=0&id=6802da98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6802da98",
  null
  
)

export default component.exports